<template>
    <!-- The Modal -->
    <div id="myModal" class="my-modal" ref="modal"  tabindex="0" @click="closeModal">
        <!-- The Close Button -->
        <!--<span class="close" onclick="document.getElementById('myModal').style.display='none'" >&times;</span>-->

        <!-- Modal Content (The Image) -->
        <img class="my-modal-content" id="img01" ref="modalImage" >

        <!-- Modal Caption (Image Text) -->
        <div id="caption" ref="caption" >
            <h2>{{text}}</h2>
        </div>
    </div>
</template>

<script>

    export default {
        data () {
            return {
                text : ""
            }
        },
        methods : {
            openModal (src, text) {
                this.$refs.modalImage.src = src;
                this.text = text;
                this.$refs.modal.style.display = "block";
                document.addEventListener('keyup', this.escapeKeyListener);
            },
            closeModal() {
                document.removeEventListener('keyup', this.escapeKeyListener);
                this.$refs.modal.style.display = "none";
            },
            escapeKeyListener: function(evt) {
                if (evt.keyCode === 27) {
                    this.closeModal();
                }
            }
        }
    }

</script>

<style scoped>

    .my-modal {
        display: none;
        /* Hidden by default */
        position: fixed;
        /* Stay in place */
        z-index: 999999;
        /* Sit on top */
        padding-top: 100px;
        /* Location of the box */
        left: 0;
        top: 0;
        width: 100%;
        /* Full width */
        height: 100%;
        /* Full height */
        overflow: auto;
        /* Enable scroll if needed */
        background-color: rgb(0, 0, 0);
        /* Fallback color */
        background-color: rgba(0, 0, 0, 0.9);
        /* Black w/ opacity */
    }

    .my-modal-content {
        margin: auto;
        display: block;
        width: 60%;
    }

    #caption {
        margin: auto;
        display: block;
        width: 80%;
        max-width: 700px;
        text-align: center;
        color: #ccc;
        padding: 10px 0;
        height: 150px;
        overflow: hidden;
    }

    .modal-content,
    #caption {
        -webkit-animation-name: zoom;
        -webkit-animation-duration: 0.6s;
        animation-name: zoom;
        animation-duration: 0.6s;
    }

    @-webkit-keyframes zoom {
        from {
            -webkit-transform: scale(0)
        }
        to {
            -webkit-transform: scale(1)
        }
    }

    @keyframes zoom {
        from {
            transform: scale(0)
        }
        to {
            transform: scale(1)
        }
    }

    .close {
        position: absolute;
        top: 15px;
        right: 35px;
        color: white;
        font-size: 40px;
        font-weight: bold;
        transition: 0.3s;
        z-index: 6;
    }

    .close:hover,
    .close:focus {
        color: #bbb;
        text-decoration: none;
        cursor: pointer;
    }

    @media only screen and (max-width: 700px) {
        .modal-content {
            width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/modals/ImageDisplayModal.vue